import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67e37517"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-group mark-as-button dropright" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Status", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuLink"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status != 'DONE')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-secondary border-normal btn-sm bg-DONE",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.set('DONE')))
        }, " Mark as done "))
      : _createCommentVNode("", true),
    (_ctx.status == 'DONE')
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn-secondary border-normal btn-sm bg-IN_PROGRESS",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.set('IN_PROGRESS')))
        }, " Mark as in progress "))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["btn btn-sm dropdown-toggle dropdown-toggle-split", { 'bg-DONE': _ctx.status != 'DONE', 'bg-IN_PROGRESS': _ctx.status == 'DONE' }]),
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, _hoisted_3, 2),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "dropdown-item",
          href: "#",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.set('TODO')), ["prevent"]))
        }, "Mark as todo")
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "dropdown-item",
          href: "#",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.set('IN_PROGRESS')), ["prevent"]))
        }, "Mark as in progress")
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "dropdown-item",
          href: "#",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.set('STUCKED')), ["prevent"]))
        }, "Mark as stucked")
      ])
    ])
  ]))
}